// Visitor identity + capture helpers (public — no auth). Talks to /crm-api.
import axios from 'axios';

const pub = axios.create({ baseURL: '/crm-api' });

function uuid() {
  if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
  return 'v-' + Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function getVisitorId() {
  let id = localStorage.getItem('dfc_visitor_id');
  if (!id) { id = uuid(); localStorage.setItem('dfc_visitor_id', id); }
  return id;
}

// Campaign attribution: capture ?c=<code> from the URL and remember it for this device.
export function getCampaign() {
  try {
    const fromUrl = new URLSearchParams(window.location.search).get('c');
    if (fromUrl) { localStorage.setItem('dfc_campaign', fromUrl); return fromUrl; }
    return localStorage.getItem('dfc_campaign') || null;
  } catch { return null; }
}

// Fire on card/microsite open — creates/updates visitor + opens a session.
export function trackVisit(employeeSlug, source) {
  const visitorId = getVisitorId();
  getCampaign(); // capture ?c= into storage on landing
  pub.post('/visit', { visitorId, employeeSlug, source, referrer: document.referrer || null }).catch(() => {});
  return visitorId;
}

// Fire a granular engagement event (product view, brochure, WhatsApp click…) — powers the timeline.
export function trackEvent(type, label, { employeeSlug, source } = {}) {
  pub.post('/event', { visitorId: getVisitorId(), type, label, employeeSlug, source }).catch(() => {});
}

// Submit an enquiry — creates/updates a lead (dedup on the server).
export function submitEnquiry({ employeeSlug, name, email, phone, company, city, interest, message, source = 'microsite', consent }) {
  return pub.post('/capture', {
    visitorId: getVisitorId(), employeeSlug, name, email, phone, company, city, interest, message, source,
    consent: consent === true,        // affirmative opt-in from the form's checkbox
    campaign: getCampaign(), // attribute the lead to its campaign (if any)
  }).then((r) => r.data);
}
